export default __webpack_public_path__ + "static/media/maintenance.41022742.png";